import { PageBreadcrumbs, PageNavigation } from '@client/toolkit';
import { PageContentSections } from './page-content-sections';
import { PageContentAnimation } from './page-content-animation';

export function ReportPageContent({
  breadcrumb,
  menu,
  children,
}: {
  breadcrumb: string;
  menu: React.ReactNode;
  children: React.ReactNode;
}) {
  return (
    <PageContentSections>
      <PageNavigation size="none">
        <PageBreadcrumbs>
          <PageBreadcrumbs.Link>{breadcrumb}</PageBreadcrumbs.Link>
        </PageBreadcrumbs>
      </PageNavigation>
      <PageContentAnimation>
        <div className="mb-5">{menu}</div>
        <div className="flex flex-col gap-5 pb-10">{children}</div>
      </PageContentAnimation>
    </PageContentSections>
  );
}
